import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Technologies } from "@/components/Technologies";
import { Products } from "@/components/Products";
import { OurWork } from "@/components/OurWork";
import { BlogPreview } from "@/components/Blog/BlogPreview";
import { SEO, seoConfig } from "@/components/SEO";

export function Home() {
  return (
    <>
      <SEO {...seoConfig.home} />
      <Hero />
      <Services />
      <Technologies />
      <Products />
      <OurWork />
      <BlogPreview />
    </>
  );
}
